import React from 'react';
import { Button, Space } from 'antd';
import { FormikProps } from 'formik';

import { PromptProps } from '../../service/ai.interface';

interface PromptSaveButtonProps {
    formik: FormikProps<PromptProps>;
    loading: boolean;
}

export const PromptSaveButton: React.FC<PromptSaveButtonProps> = ({
    formik,
    loading,
}) => {
    return (
        <Space>
            <Button
                type='primary'
                onClick={() => formik.handleSubmit()}
                loading={loading}
                disabled={!formik.dirty}
            >
                Сохранить
            </Button>
        </Space>
    );
};
